import * as R from 'ramda'

import { putRequest } from 'lib/api/api'
import store from 'lib/store'
import { RESET_STORE } from 'lib/store/rootReducer'
import { history } from 'lib/utils/navigation'
import {
  DASHBOARD_ROUTE,
  getRoute,
} from 'domains/application/navigation/routes'
import { auth0Login } from 'domains/authentication/hooks/useAutoAuth0Login'
import trackAuthenticationAnalytics from 'domains/authentication/utils/trackAuthenticationAnalytics'

export const login = async (orgId?: number): Promise<boolean> => {
  let response

  if (orgId) {
    response = await putRequest(`login/${orgId}`)
  } else {
    throw new Error('Organization ID is required for login')
  }

  if (response.success) {
    const redirectUrl = R.pathOr(
      DASHBOARD_ROUTE,
      ['location', 'state', 'redirectUrl'],
      history,
    )

    if (orgId) {
      store.dispatch({ type: RESET_STORE })
      await auth0Login()
      history.push(getRoute(redirectUrl))
    } else {
      trackAuthenticationAnalytics('successful_login')
      await auth0Login()
      history.push(getRoute(redirectUrl))
    }

    return true
  } else {
    trackAuthenticationAnalytics('failed_login')

    return false
  }
}
